import { BaseNetworkActionHelper } from '../base.network.action.helper';
import { ADSyncerSpecifics, ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { RemoveAdIntegratorPopUpSpecifics } from '../../../../networkPopUps/popUps/removeADIntegrator/types';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../../utils/request';

export class RemoveAdIntegratorActionHelper extends BaseNetworkActionHelper {
  public async processAction(records: Array<ProtectedEntity>): Promise<RemoveAdIntegratorPopUpSpecifics> {
    if (records.length !== 1) {
      // We shouldn't reach this point, it should be handled by remove.ad.integrator.validator.ts
      throw new Error('Only one record can be selected');
    }

    const computerData = records[0];
    const computerSpecifics: ADSyncerSpecifics = computerData.specifics as ADSyncerSpecifics;
    if (!computerSpecifics.domainId || !computerData.company?.id) {
      return {
        isError: false,
      };
    }

    const result = await ConsoleRequest.createRequest<{ count: number; domainName: string }>({
      dataProviderType: DataProviderType.ENDPOINTS,
      dataProviderEntity: DataProviderEntity.MODEL,
      endpoint: 'UnifiedEndpoints',
      method: 'checkDomainIntegrators',
      payload: {
        domainId: computerSpecifics.domainId,
        companyId: computerData.company.id,
      },
    });

    return result.count > 1 ? { isError: false } : { isError: false, domainName: result.domainName };
  }
}
